export function dependencyGender(value: string | null | undefined): "M" | "Z" {
    return value === "M" ? "M" : "Z"
}
